export default function ServicesCTA() {
  return (
    <section className="w-full bg-[#09090B] py-28 px-6 border-t border-white/5">
      <div className="max-w-4xl mx-auto text-center relative">
        {/* Glow */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: "radial-gradient(ellipse at 50% 50%, rgba(74,222,128,0.06) 0%, transparent 70%)",
          }}
        />

        <div className="relative z-10">
          <div className="inline-block text-xs font-semibold uppercase tracking-widest text-[#4ADE80]/80 mb-6">
            Ready to Build
          </div>
          <h2
            className="text-4xl md:text-6xl font-bold text-white leading-tight tracking-tight mb-6"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Your Systems Should Support Your Growth—
            <span className="text-[#4ADE80]">Not Limit It</span>
          </h2>
          <p className="text-lg text-white/45 max-w-xl mx-auto mb-10 leading-relaxed">
            Stop patching broken systems. Start building a structured foundation that compounds over time.
          </p>
          <a
            href="/#get-started"
            className="whitespace-nowrap inline-flex items-center gap-3 px-10 py-5 rounded-lg bg-[#4ADE80] text-[#09090B] font-bold text-lg hover:bg-[#22C55E] transition-all duration-200 cursor-pointer"
          >
            Start Your Build <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
